import { FormType } from '@aloft/toolkit-shared';

import { selectSubjectPropertyType } from '../../redux/features/selectors/selectSubjectPropertyType.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { ExportModalAppraiseItProExport } from './ExportModalAppraiseItProExport.tsx';
import { ExportModalClickFormsExport } from './ExportModalClickFormsExport.tsx';
import { ExportModalPdfExport } from './ExportModalPdfExport.tsx';
import { ExportModalTotalExport } from './ExportModalTotalExport.tsx';
import { ClickFormsExisting, ExportType } from './types.ts';

export const ExportModalExportTypes = ({
  exportType,
  clickFormsExisting,
  setClickFormsExisting,
  formType,
  setFormType,
  includeAnnotations,
  setIncludeAnnotations,
}: {
  exportType?: ExportType;
  clickFormsExisting?: ClickFormsExisting;
  setClickFormsExisting: (val: ClickFormsExisting) => void;
  formType: FormType;
  setFormType: (val: FormType) => void;
  includeAnnotations: boolean;
  setIncludeAnnotations: (val: boolean) => void;
}) => {
  const propertyType = useAppSelector(selectSubjectPropertyType);

  switch (exportType) {
    case 'pdf':
      return <ExportModalPdfExport />;
    case 'total':
      return (
        <ExportModalTotalExport
          formType={formType}
          setFormType={setFormType}
          propertyType={propertyType}
          includeAnnotations={includeAnnotations}
          setIncludeAnnotations={
            propertyType === 'singleFamilyResidence' ? setIncludeAnnotations : undefined
          }
        />
      );
    case 'appraise-it':
      return (
        <ExportModalAppraiseItProExport
          formType={formType}
          setFormType={setFormType}
          propertyType={propertyType}
        />
      );
    case 'click-forms':
      return (
        <ExportModalClickFormsExport
          clickFormsExisting={clickFormsExisting}
          setClickFormsExisting={setClickFormsExisting}
          formType={formType}
          setFormType={setFormType}
          propertyType={propertyType}
        />
      );
    default:
      return null;
  }
};
